<div class="w-full flex flex-col item-center">
  <span class="mt-4 text-center">
    {{ '#UTILITIES.WELCOME' | translate | interpolate: (userContext$ | async) }}
  </span>
</div>
